module.exports = __webpack_public_path__ + "static/media/picture-(54).e14a2041.JPG";